import { BriefcaseBusiness, GraduationCap, Code2, HeartHandshake } from "lucide-react";
import JourneyStage from "../types/JourneyStageProps";

const journeyData: JourneyStage[] = [
  {
    year: "Start",
    title: "My Career Journey",
    description:
      "A timeline of how I grew from an early programming student into a full-stack developer through study, challenge, persistence, and hands-on project experience.",
    icon: <BriefcaseBusiness size={28} />,
  },
  {
    year: "2020",
    title: "I learnt C/C++ in China at CDTU",
    description:
      "This was the beginning of my programming journey. I built my first foundation in problem solving and coding with C/C++ during university study in China.",
    icon: <Code2 size={28} />,
  },
  {
    year: "2022",
    title: "I left university during COVID-19",
    description:
      "During the pandemic, my academic path was interrupted. Although this was a difficult stage, it became a turning point that later pushed me to rebuild my direction and continue moving forward.",
    icon: <BriefcaseBusiness size={28} />,
  },
  {
    year: "2023",
    title: "I got access to the University of Auckland as a Computer Science student",
    description:
      "I started a new chapter at the University of Auckland and continued building my academic and technical skills in Computer Science.",
    icon: <GraduationCap size={28} />,
  },
  {
    year: "2023",
    title: "I learnt HTML, CSS, JavaScript, and Python",
    description:
      "I strengthened my web and programming fundamentals by learning front-end basics and Python, which helped me gain confidence in both development logic and page building.",
    icon: <Code2 size={28} />,
  },
  {
    year: "2024",
    title: "I expanded my technical foundation through coursework and projects",
    description:
      "I learnt Java, C#, C, SQL, database design, Git, and GitHub. I built a game library website, a concert booking system, and a simple version control system on Linux. I also passed both the three-hour backend development test and the three-hour frontend development test in COMPSCI 335.",
    icon: <Code2 size={28} />,
  },
  {
    year: "2025",
    title: "I became a stronger full-stack developer",
    description:
      "I learnt the MERN stack, TypeScript, Docker, AWS services, networking, cryptography, blockchain, and cybersecurity. Through building a capstone project website, I developed a much deeper understanding of full system architecture and modern full-stack development.",
    icon: <BriefcaseBusiness size={28} />,
  },
  {
    year: "2026",
    title: "I graduated from the University of Auckland",
    description:
      "I graduated with an overall programme GPA of 6.29 out of 9. I am also currently volunteering at Age Concern, where I continue contributing to the community while growing professionally.",
    icon: <HeartHandshake size={28} />,
  },
];

export default journeyData;